import { CircleBoldIcon, IconWrap } from '@libs/ui/ds'
import type { ReactElement } from 'react'

export const NO_LABEL_VALUE = 'NO_LABEL'
const NO_LABEL_COLOR = '#f6f7fa'

type LabelType = {
  value: string
  label: string
  color: string
  leftIcon: ReactElement
}

export const getLabelFormatted = ({
  value,
  label,
  color
}: {
  value?: string
  label?: string
  color?: string
}) => {
  const formattedLabel: LabelType = {
    value: value ?? NO_LABEL_VALUE,
    label: label ?? '',
    color: color ?? NO_LABEL_COLOR,
    leftIcon: (
      <IconWrap
        icon={<CircleBoldIcon />}
        size='m'
        style={{ color: color ?? NO_LABEL_COLOR }}
      />
    )
  }
  return formattedLabel
}
